var AppDispatcher = require('../dispatchers/AppDispatcher');
var BaseStore = require('./BaseStore');
var CardValidator = require('../validators/CardValidator');
var Constants = require('../constants/Constants');
var Invocation = require('../api/Invocation');
var TokenConstants = require('../constants/Token');
var UserStore = require('./UserStore');

var PaymentTokenStore = new BaseStore({
    defaultData: []
});
PaymentTokenStore._newCard = {};
PaymentTokenStore.cardErrors = [];
PaymentTokenStore.tokenUsageMap = {};

PaymentTokenStore.getNewCard = function () {
    return this._newCard;
};
PaymentTokenStore.getNewCardErrors = function () {
    return this.cardErrors;
};

PaymentTokenStore.updateTokenUsageMap = function (billingGroups) {
    this.tokenUsageMap = {};

    billingGroups.forEach(bg => {
        if (bg.payment_token !== null) {
            this.tokenUsageMap[bg.payment_token] = this.tokenUsageMap[bg.payment_token] || [];
            this.tokenUsageMap[bg.payment_token].push(bg.name);
        }
    });
};

PaymentTokenStore._handleTokenErrors = function (err) {
    var errors = [];

    if (err.res.body.violations && err.res.body.violations.length) {
        errors = err.res.body.violations;
    }
    if (!errors.length) {
        errors.push({ property_path: 'card.number', message: 'An error has occurred. Please check your card details and try again.' });
    }

    if (errors.length) {
        err.handled = true;
    }

    this.cardErrors = errors;

    throw err;
};

PaymentTokenStore.register(TokenConstants.UPDATE_CARD, function (payload) {
    this._newCard = payload.action.card;

    return true;
});

PaymentTokenStore.register(TokenConstants.SAVE, function (payload) {
    this.cardErrors = CardValidator.validateCard(this._newCard);
    if (this.cardErrors.length) {
        return true;
    }

    this._loading = true;
    this._savingNewCard = true;
    this.emitChange();

    const callback = payload.action.callback;
    const billingGroupDefaults = payload.action.billingGroupDefaults;

    var { ...card } = this._newCard;
    card.expiry_month = card.expiryMonth;
    card.expiry_year = card.expiryYear;
    delete card.expiryMonth;
    delete card.expiryYear;

    const clientId = UserStore.getClientId();

    var promise = Invocation.billing.addToken(clientId, card, billingGroupDefaults)
        .catch((err) => {
            this._savingNewCard = false;
            this._handleTokenErrors(err)
        })
        .then(function (res) {
            this._savingNewCard = false;
            const token = res.body.token;
            AppDispatcher.handleRequestAction({
                actionType: TokenConstants.NEW_PAYMENT_TOKEN_POST_SAVE,
                billingGroupDefaults,
                token
            });

            this._data.push(token);

            return token;
        }.bind(this));

    if (callback) {
        promise = promise.then(callback);
    }

    promise
        .then(() => this.finish())
        .catch((err) => this.finishWithErrors(err))
        .done();

    return true;
});

PaymentTokenStore.register(Constants.api.GET_SERVICES, function (payload) {
    var action = payload.action;

    if (action.state === Constants.request.PENDING) {
        this._loading = true;

        return true;
    }

    if (action.state === Constants.request.FINISHED) {
        this._loading = false;
        this.setData(action.response.body.client.payment_tokens);
        this.updateTokenUsageMap(action.response.body.client.billing_groups);

        return true;
    }
});

PaymentTokenStore.register(Constants.api.DELETE_TOKEN, function (payload) {
    var action = payload.action;
    var deletedToken = action.params.token;

    if (action.state === Constants.request.PENDING) {
        this._deletingToken = deletedToken;

        return true;
    }

    if (action.state === Constants.request.FINISHED) {
        this._deletingToken = null;

        this.setData(this.get().filter(
            token => token.uuid != deletedToken.uuid,
        ));

        delete this.tokenUsageMap[deletedToken.uuid];

        return true;
    }
});

module.exports = PaymentTokenStore;



// WEBPACK FOOTER //
// ./app/stores/PaymentTokenStore.js